import { ReplayFrameEvent } from '@sentry/react';
import { FILTERED_BY_DEV } from './constants';

export const isNetworkRequestEvent = (event: ReplayFrameEvent): boolean =>
  event.data.tag === 'performanceSpan' &&
  (event.data.payload.op === 'resource.fetch' ||
    event.data.payload.op === 'resource.xhr');

export const scrubSensitiveData = (obj: any, fieldName: string) => {
  if (obj && typeof obj === 'object') {
    for (const key in obj) {
      if (key === fieldName) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        obj[key] = FILTERED_BY_DEV;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      } else if (typeof obj[key] === 'object') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        scrubSensitiveData(obj[key], fieldName);
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return obj;
};
